import compose from 'lodash/flowRight'
import {connect} from 'react-redux'

import type {State} from '../../../../reducers/types'
import {getOverviewHref} from '../../../../routes'
import {makeGetBuilds, getBuildsReady, getBuild} from '../../../../selectors'
import type {Branch} from '../../../../services/rest'
import type {BuildId} from '../../../../types'
import type {SeqProps} from '../../SequenceLoader/SequenceLoader'
import {withSequenceLoaderReadyHandler} from '../../SequenceLoader/SequenceLoader.hooks'

import SnapshotDependenciesCounters from './SnapshotDependenciesCounters'
import {
  getSnapshotDependenciesCounters,
  getSnapshotDependenciesLocator,
} from './SnapshotDependenciesCounters.utils'

type OwnProps = SeqProps & {
  buildId?: BuildId | null | undefined
  branch?: Branch | null | undefined
  className?: string
}
type StateProps = {
  locator: string
  overallCount: number
  finishedFailed: number
  finishedSuccessful: number
  queued: number
  canceled: number
  failedToStart: number
  runningFailed: number
  runningSuccessful: number
  dependenciesTabLink: string
  isReady: boolean
}

const mapStateToProps: () => (state: State, props: OwnProps) => StateProps = () => {
  const getBuilds = makeGetBuilds()
  return (state, {buildId}) => {
    const locator = getSnapshotDependenciesLocator(buildId)
    const builds = getBuilds(state, locator)
    const overallCount = builds.length
    const {
      finishedFailed,
      finishedSuccessful,
      queued,
      canceled,
      failedToStart,
      runningFailed,
      runningSuccessful,
      overdue,
    } = getSnapshotDependenciesCounters(builds)

    return {
      locator,
      overallCount,
      finishedFailed,
      finishedSuccessful,
      queued,
      canceled,
      failedToStart,
      runningFailed,
      runningSuccessful,
      overdue,
      dependenciesTabLink: `${getOverviewHref({
        buildId,
        buildTypeId: getBuild(state, buildId)?.buildType,
      })}?buildTab=dependencies`,
      isReady: getBuildsReady(state, locator),
    }
  }
}

export default compose(
  connect(mapStateToProps),
  withSequenceLoaderReadyHandler,
)(SnapshotDependenciesCounters)
